
import Vue from "vue";
export default Vue.extend({
  name: "progress-item",

  /**
   * item - 进度节点
   *      status - 状态 0 已完成的节点、1 当前节点、 2 未激活节点
   *      text - 节点文本
   * last - 是否是最后一个节点
   */
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },

    last: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      icon: "",
    };
  },

  methods: {
    setIcon() {
      this.icon =
        this.item.status === 0
          ? "./img/勾选拷贝9@2x.png"
          : this.item.status === 1
          ? "./img/节点进行中@2x.png"
          : "./img/入驻审核@2x.png";
    },
  },

  mounted() {
    this.setIcon();
  },

  updated() {
    this.setIcon();
  },
});
